import { CheckCircleOutlined, EnvironmentOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Avatar, Card, Col, Divider, Row, Tag, Typography } from 'antd'
import React from 'react'
import { useLocation } from 'react-router-dom'

const BusinessDashboard = () => {
    const location = useLocation();
    const business = location.state.business;
    const url = location.state.url;
    console.log(business);
    const { Title, Text } = Typography;

    return (
        <Row justify={'center'}>
            <Col md={14} xs={24}>
                <Row gutter={[16, 16]} style={{ padding: "20px" }}>
                    {/* Business Info */}
                    <Col span={24}>
                        <Card>
                            <Row align="middle" gutter={16}>
                                <Col>
                                    <Avatar size={100} src={url + '/' + business.logo} />
                                </Col>
                                <Col>
                                    <Title level={3}>{business.business_name}</Title>
                                    <Text type="secondary">{business.established} in Business</Text>
                                    <div>
                                        <Tag color="green">{business.avg} ★</Tag>
                                        <Text>({business.rating.length} Ratings)</Text>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>

                    {/* Dashboard Stats */}
                    <Col span={12}>
                        <Card>
                            <Title level={5}>Total Clicks</Title>
                            <Text>{business.visitors_count}</Text>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card>
                            <Title level={5}>Total Calls</Title>
                            <Text>{business.call_clicked_count}</Text>
                        </Card>
                    </Col>

                    {/* Status */}
                    <Col span={24}>
                        <Card>
                            <Title level={5}>Status</Title>
                            <Tag color={business.status === 1 ? "green" : "orange"}>
                                {business.status === 1 ? <CheckCircleOutlined /> : <ExclamationCircleOutlined />}{" "}
                                {business.status === 1 ? "Approved" : "Pending"}
                            </Tag>
                        </Card>
                    </Col>

                    {/* Address */}
                    <Col span={24}>
                        <Card>
                            <Text><EnvironmentOutlined /> {business.address}, {business.city}, {business.pincode}</Text>
                        </Card>
                    </Col>

                    {/* About */}
                    <Col span={24}>
                        <Card>
                            <Title level={5}>About Us</Title>
                            <Text>{business.description}</Text>
                        </Card>
                    </Col>

                    {/* Services */}
                    {business.services.length > 0 && (
                        <Col span={24}>
                            <Card>
                                <Title level={5}>Our Services</Title>
                                {business.services.map((d, i) => (
                                    <Tag color="blue" key={i}>{d.service.service}</Tag>
                                ))}
                            </Card>
                        </Col>
                    )}

                    {/* Reviews & Ratings */}
                    <Col span={24}>
                        <Card>
                            <Title level={5}>Reviews & Ratings</Title>
                            <Tag color="green">{business.avg} ★</Tag>
                            <Text>{business.rating.length} Ratings</Text>
                            <Divider />
                            {business.rating.map((d, i) => (
                                <Card key={i} style={{ marginBottom: "10px" }}>
                                    <Row justify="space-between">
                                        <Col>
                                            <Title level={5}>{d.user.name}</Title>
                                            <Text>{d.rating} ★</Text>
                                        </Col>
                                        <Col>
                                            <Text type="secondary">{d.created_at}</Text>
                                        </Col>
                                    </Row>
                                    <Text>{d.review}</Text>
                                </Card>
                            ))}
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default BusinessDashboard